import { ProjectDetailsCard } from './ProjectDetailsCard';
import { Box } from '@mui/system';
import { useRecoilValue } from 'recoil';
import { projectState } from 'state';

export default function ProjectDashboard() {
  const { selectedProject } = useRecoilValue(projectState);
  return (
    <Box sx={{ pb: 10 }}>
      <ProjectDetailsCard project={selectedProject} />
    </Box>
  );
}
